import 'styled-components/macro';
import React, { useState, useEffect, useCallback } from 'react';

// import HelpIcon from '@mui/icons-material/Help';
import { useApolloClient } from '@apollo/react-hooks';
import { Box, ButtonBase, Grid, Toolbar, Tooltip, useMediaQuery, Button, Hidden } from '@material-ui/core';
import { useDrawerPassword } from 'context/useDrawerPassword';
import lodash from 'lodash';
import { MdPerson, MdHelp } from 'react-icons/md';
import { useHistory, Link } from 'react-router-dom';

import { DrawerMobile } from './DrawerMobile';
import { StyledDrawerAppBar, StyledMainContent, VerticalBar } from './styles';

import { BpmIcon } from 'assets/BpmIcon';
import { CRMIcon } from 'assets/CRMIcon';
import { GedIcon } from 'assets/GedIcon';
import { PdvIcon } from 'assets/PdvIcon';
import QuickRPIcon from 'assets/quick_icon.svg';
import { DrawerPassword } from 'components/molecules/DrawerPassword';
import { TooltipedButton } from 'components/TooltipedButton';
import { TypographyCN } from 'components/TypographyCN';
import { MenuItemReport } from 'pages/Report/Components/MenuItem';
import { useStyledTheme } from 'styles';
import { isReportOrDashboardPage } from 'utils/isReportOrDashboardPage';
import { NavBarMobileLink, NavbarProlifeLink } from 'utils/navbarLink';
import { useGetLoggedEmployeeNoCache } from 'utils/useGetEmployee';
import { useGetSimplifiedPermissionsQueries } from 'utils/useGetEmployeeSimplePermissions';
import { useIsLoggedIn } from 'utils/useInLoggedIn';
import { useRouter } from 'utils/useRouter';

interface Props {
  children: React.ReactNode;
}

type DrawerType = {
  children: React.ReactNode;
};

export function Drawer({ children }: Props) {
  const client = useApolloClient();
  const simplifiedPermissionsByDescription = useGetSimplifiedPermissionsQueries();
  const permittedDescriptions = simplifiedPermissionsByDescription?.data?.permissoesSimplificadas?.agrupadoPorDescricao;
  const mappedPermissions = permittedDescriptions?.map(pd => pd?.permssaoDescricao) || [];
  const navbarModulesWithPermission = NavBarMobileLink.filter(navbarModule => {
    const flattenLinks = lodash.flatten(navbarModule.data.map(linkValue => linkValue.permissions));
    return lodash.difference(flattenLinks, mappedPermissions).length < flattenLinks.length;
  }).map(navbarModule => {
    // Verifica dentro de cada modulo se tenho permissao para as .permissions do mesmo
    // E sobrescreve o parametro data com os modulos permitidos
    const filteredModule = navbarModule.data.filter(d => {
      return lodash.difference(d.permissions, mappedPermissions).length < d.permissions.length;
    });
    return {
      ...navbarModule,
      data: filteredModule,
    };
  });

  const { push } = useHistory();
  const { pathname } = useRouter();
  const isLogged = useIsLoggedIn();
  if (isLogged === false) push('/');

  const hasPathnameName = (url: string) => {
    return pathname.includes(url);
  };

  const { openDrawerPassword, setOpenDrawerPassword, onClose, onDrawerMobile } = useDrawerPassword();

  const [openGed, setOpenGed] = useState(false);
  const [anchorElGed, setAnchorElGed] = useState(null);

  const [openPdv, setOpenPdv] = useState(false);
  const [anchorElPdv, setAnchorElPdv] = useState(null);

  const [openCrm, setOpenCrm] = useState(false);
  const [anchorElCrm, setAnchorElCrm] = useState(null);

  const [openBpm, setOpenBpm] = useState(false);
  const [anchorElBpm, setAnchorElBpm] = useState(null);

  const [openProfile, setOpenProfile] = useState(false);
  const [anchorElProfile, setAnchorElProfile] = useState(null);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const backgroundModuleColor = (isSelectedMacro: boolean) => (isSelectedMacro ? '#024E7C' : '#0370B2');
  const theme = useStyledTheme();
  const downBreakPoint = useMediaQuery(theme.breakpoints.down(1024));
  const moduleHomePage = isReportOrDashboardPage(pathname);

  const { data } = useGetLoggedEmployeeNoCache();

  function handleMenu(event: React.MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget);
  }

  const handleOpenDrawerPassword = () => {
    setOpenDrawerPassword(!openDrawerPassword);
  };

  const handleClickPdv = (event: any) => {
    !openPdv ? setAnchorElPdv(event.currentTarget) : setAnchorElPdv(null); // ged
    !!openGed && setOpenGed(!openGed); // pdv
    anchorElGed !== null && setAnchorElGed(null); //pdv
    setOpenPdv(!openPdv); // ged
    !!openCrm && setOpenCrm(!openCrm);
    anchorElCrm !== null && setAnchorElCrm(null);
    !!openBpm && setOpenBpm(!openBpm);
    anchorElBpm !== null && setAnchorElBpm(null);
    !!openProfile && setOpenProfile(!openProfile);
    anchorElProfile !== null && setAnchorElProfile(null);
  };

  const handleClickGed = (event: any) => {
    !openGed ? setAnchorElGed(event.currentTarget) : setAnchorElGed(null);
    setOpenGed(!openGed);
    !!openPdv && setOpenPdv(!openPdv);
    anchorElPdv !== null && setAnchorElPdv(null);
    !!openCrm && setOpenCrm(!openCrm);
    anchorElCrm !== null && setAnchorElCrm(null);
    !!openBpm && setOpenBpm(!openBpm);
    anchorElBpm !== null && setAnchorElBpm(null);
    !!openProfile && setOpenProfile(!openProfile);
    anchorElProfile !== null && setAnchorElProfile(null);
  };

  const handleClickCrm = (event: any) => {
    !openCrm ? setAnchorElCrm(event.currentTarget) : setAnchorElCrm(null);
    !!openGed && setOpenGed(!openGed);
    anchorElGed !== null && setAnchorElGed(null);
    !!openPdv && setOpenPdv(!openPdv);
    anchorElPdv !== null && setAnchorElPdv(null);
    setOpenCrm(!openCrm);
    !openCrm ? setAnchorElCrm(event.currentTarget) : setAnchorElCrm(null);
    !!openBpm && setOpenBpm(!openBpm);
    anchorElBpm !== null && setAnchorElBpm(null);
    !!openProfile && setOpenProfile(!openProfile);
    anchorElProfile !== null && setAnchorElProfile(null);
  };

  const handleClickBpm = (event: any) => {
    !openBpm ? setAnchorElBpm(event.currentTarget) : setAnchorElBpm(null);
    !!openGed && setOpenGed(!openGed);
    anchorElGed !== null && setAnchorElGed(null);
    !!openPdv && setOpenPdv(!openPdv);
    anchorElPdv !== null && setAnchorElPdv(null);
    !!openCrm && setOpenCrm(!openCrm);
    anchorElCrm !== null && setAnchorElCrm(null);
    setOpenBpm(!openBpm);
    !openBpm ? setAnchorElBpm(event.currentTarget) : setAnchorElBpm(null);
    !!openProfile && setOpenProfile(!openProfile);
    anchorElProfile !== null && setAnchorElProfile(null);
  };

  const handleClickProfile = (event: any) => {
    !!openGed && setOpenGed(!openGed);
    anchorElGed !== null && setAnchorElGed(null);
    !!openPdv && setOpenPdv(!openPdv);
    anchorElPdv !== null && setAnchorElPdv(null);
    !!openCrm && setOpenCrm(!openCrm);
    anchorElCrm !== null && setAnchorElCrm(null);
    !!openBpm && setOpenBpm(!openBpm);
    anchorElBpm !== null && setAnchorElBpm(null);
    console.log('openProfile', openProfile);
    setOpenProfile(!openProfile);
    !openProfile ? setAnchorElProfile(event.currentTarget) : setAnchorElProfile(null);
  };

  function onDashboardPage() {
    push('/dashboard');
  }

  const isSelectedModulePdvURL =
    !openDrawerPassword &&
    (hasPathnameName('clientes') || hasPathnameName('emprestimos') || hasPathnameName('relatorios'));
  const isSelectedModuleFinancasURL =
    !openDrawerPassword && (hasPathnameName('contas') || hasPathnameName('reembolsos'));
  const isSelectedModuleGestaoURL =
    !openDrawerPassword &&
    (hasPathnameName('lojas') ||
      hasPathnameName('funcionarios') ||
      (hasPathnameName('metas') && !hasPathnameName('relatorios')));
  const isSelectedModuleMarketingURL = !openDrawerPassword && (hasPathnameName('crm') || hasPathnameName('zeki-bot'));

  const handleClickOut = () => {
    !!openGed && setOpenGed(!openGed);
    anchorElGed !== null && setAnchorElGed(null);
    !!openPdv && setOpenPdv(!openPdv);
    anchorElPdv !== null && setAnchorElPdv(null);
    !!openCrm && setOpenCrm(!openCrm);
    anchorElCrm !== null && setAnchorElCrm(null);
    !!openBpm && setOpenBpm(!openBpm);
    anchorElBpm !== null && setAnchorElBpm(null);
    !!openProfile && setOpenProfile(!openProfile);
    anchorElProfile !== null && setAnchorElProfile(null);
  };

  return (
    <Box display="flex">
      <StyledDrawerAppBar id="navbar-main" position="fixed" style={{ zIndex: 10000 }} onClick={handleClickOut}>
        <Toolbar
          style={{
            width: '100%',
            maxWidth: '1920px',
            flexDirection: downBreakPoint ? 'row-reverse' : 'row',
            justifyContent: downBreakPoint ? 'space-between' : undefined,
          }}
        >
          <Grid
            xs={6}
            item
            style={{
              display: 'flex',
              justifyContent: 'start',
              alignItems: 'center',
            }}
          >
            <Tooltip title="Dashboard">
              <Link to="/dashboard" onClick={onDashboardPage}>
                <img
                  src={QuickRPIcon}
                  alt="QuickRPIcon"
                  style={{
                    marginLeft: !downBreakPoint ? '1rem' : -40,
                    padding: '0.5rem',
                    width: '7rem',
                    cursor: 'pointer',
                  }}
                />
              </Link>
            </Tooltip>
          </Grid>

          <Grid item xs={6} spacing={2}>
            {!downBreakPoint ? (
              <Grid
                xs={12}
                item
                container
                style={{
                  justifyContent: 'end',
                  alignItems: 'center',
                  margin: 0,
                  gap: '1rem',
                }}
                spacing={2}
              >
                {navbarModulesWithPermission.map(e => (
                  <>
                    {e.id === 1 && (
                      <TooltipedButton
                        fullText={e.name}
                        anchorEl={anchorElPdv}
                        data={e.data}
                        key={e.id}
                        onClick={(event: any) => {
                          handleClickPdv(event);
                        }}
                        // handleClose={() => handleChangeMacroModule()}
                        buttonColor={backgroundModuleColor(isSelectedModulePdvURL)}
                      >
                        <GedIcon fill="#FFFFFF" height="28" width="24" />
                      </TooltipedButton>
                    )}
                    {e.id === 2 && (
                      <TooltipedButton
                        fullText={e.name}
                        anchorEl={anchorElBpm}
                        data={e.data}
                        key={e.id}
                        onClick={(event: any) => {
                          handleClickBpm(event);
                        }}
                        // handleClose={() => handleChangeMacroModule()}
                        buttonColor={backgroundModuleColor(isSelectedModuleFinancasURL)}
                      >
                        <BpmIcon fill="#FFFFFF" height="28" width="24" />
                      </TooltipedButton>
                    )}
                    {e.id === 3 && (
                      <TooltipedButton
                        fullText={e.name}
                        anchorEl={anchorElGed}
                        data={e.data}
                        key={e.id}
                        onClick={(event: any) => {
                          handleClickGed(event);
                        }}
                        // handleClose={() => handleChangeMacroModule()}
                        buttonColor={backgroundModuleColor(isSelectedModuleGestaoURL)}
                      >
                        <PdvIcon fill="#FFFFFF" height="28" width="25" />
                      </TooltipedButton>
                    )}
                    {e.id === 4 && (
                      <TooltipedButton
                        fullText={e.name}
                        anchorEl={anchorElCrm}
                        data={e.data}
                        key={e.id}
                        onClick={(event: any) => {
                          handleClickCrm(event);
                        }}
                        // handleClose={() => handleChangeMacroModule()}
                        buttonColor={backgroundModuleColor(isSelectedModuleMarketingURL)}
                      >
                        <CRMIcon fill="#FFFFFF" height="28" width="24" />
                      </TooltipedButton>
                    )}
                  </>
                ))}
                <TooltipedButton
                  fullText={'Ajuda'}
                  data={[]}
                  onClick={() => {
                    window.open('https://quickerp.freshdesk.com', '_blank');
                  }}
                >
                  <MdHelp color="white" size={29} />
                </TooltipedButton>

                {data?.relatorios && data.relatorios.length > 0 && (
                  <MenuItemReport reports={data.relatorios} onClose={() => setAnchorEl(null)} anchorEl={anchorEl} />
                )}

                <VerticalBar />

                <ButtonBase
                  style={{
                    gap: '0.25rem',
                  }}
                >
                  {NavbarProlifeLink.map(value => (
                    <>
                      {value.id === 1 && (
                        <TooltipedButton
                          reverseImage
                          fullText={`${value.name} | ${data?.nome}`}
                          anchorEl={anchorElProfile}
                          buttonColor={backgroundModuleColor(openDrawerPassword)}
                          data={value.data}
                          key={value.id}
                          onClick={(e: any) => {
                            handleClickProfile(e);
                          }}
                          openDrawerMobile={handleOpenDrawerPassword}
                          onExit={async () => {
                            await client.clearStore();
                            client.writeData({ data: { isLoggedIn: false } });

                            const user = localStorage.getItem('@user-saved');
                            const shouldRemember = localStorage.getItem('should_remember');

                            localStorage.clear();

                            if (!shouldRemember) {
                              localStorage.setItem('should_remember', 'false');
                              return;
                            }

                            if (shouldRemember === 'false') {
                              return;
                            }

                            localStorage.setItem('@user-saved', user as string);
                            localStorage.setItem('should_remember', 'true');
                          }}
                        >
                          <MdPerson
                            color="white"
                            size={29}
                            style={{
                              border: '2px solid white',
                              borderRadius: '50px',
                            }}
                          />
                          <TypographyCN setColor="white" style={{ textTransform: 'none' }}>
                            {Number(data?.nome?.length) > 20 ? `${data?.nome?.slice(0, 20)}...` : data?.nome}
                          </TypographyCN>
                        </TooltipedButton>
                      )}
                    </>
                  ))}
                </ButtonBase>
              </Grid>
            ) : (
              <Grid>
                <DrawerMobile
                  data={data}
                  navbarData={navbarModulesWithPermission}
                  onExit={async () => {
                    await client.clearStore();
                    client.writeData({ data: { isLoggedIn: false } });

                    const user = localStorage.getItem('@user-saved');
                    const shouldRemember = localStorage.getItem('should_remember');

                    localStorage.clear();

                    if (!shouldRemember) {
                      localStorage.setItem('should_remember', 'false');
                      return;
                    }

                    if (shouldRemember === 'false') {
                      return;
                    }

                    localStorage.setItem('@user-saved', user as string);
                    localStorage.setItem('should_remember', 'true');
                  }}
                  handleMenu={handleMenu}
                  handleOpenDrawerPassword={onDrawerMobile}
                />
              </Grid>
            )}
          </Grid>
        </Toolbar>
      </StyledDrawerAppBar>
      <DrawerPassword
        open={openDrawerPassword}
        handleCloseDrawer={() => {
          onClose();
        }}
      />
      <StyledMainContent
        css={`
          ${!moduleHomePage && 'padding-top: 4rem;'}
        `}
      >
        {children}
      </StyledMainContent>
    </Box>
  );
}
